// extracted by mini-css-extract-plugin
module.exports = {"title":"UserFeed_title__xlOMx","button":"UserFeed_button__1TjVB"};